import { Flex } from "@gravity-ui/uikit";
import { useMemo } from "react";
import { ErrorResponse, useRouteError } from "react-router-dom";
import { LandingPageHeader } from "src/pages/LandingPage/widgets";

import { NotFound, UnexpectedError } from "./widgets";

export const ErrorBoundary = () => {
  const error = useRouteError() as ErrorResponse;
  const errorContent = useMemo(() => {
    if (!error) return null;
    switch (error.status) {
      case 404:
        return <NotFound />;
      default:
        return <UnexpectedError />;
    }
  }, [error]);

  if (!error) return null;

  return (
    <Flex direction="column" justifyContent="center" alignItems="center">
      <LandingPageHeader />
      {errorContent}
    </Flex>
  );
};
